'use strict';

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

(0, _jquery2.default)('body').on('click', function (e) {
  var target = (0, _jquery2.default)(e.target);
  if (target.hasClass('cart-drawer') || target.parents('.cart-drawer').length || target.hasClass('filters-drawer') || target.parents('.filters-drawer').length || target.hasClass('bc-sf-search-suggestion-wrapper') || target.parents('.bc-sf-search-suggestion-wrapper').length || target.hasClass('bc-sf-search-suggestion-mobile-top-panel') || target.parents('.bc-sf-search-suggestion-mobile-top-panel').length || target.hasClass('js-search-container') || target.parents('.js-search-container').length || target.hasClass('js-toggle-btn') || target.parents('.js-toggle-btn').length || target.hasClass('bc-sf-search-suggestion-mobile-overlay').length || target.parents('.bc-sf-search-suggestion-mobile-overlay').length) {
    return;
  } else {
    var dataTop = Number((0, _jquery2.default)('body').attr('data-top'));

    (0, _jquery2.default)('.cart-drawer').removeClass('expanded');
    (0, _jquery2.default)('body, .filters-drawer').removeClass('expanded');
    (0, _jquery2.default)('html, body').removeClass('no-scroll expand-search');
    (0, _jquery2.default)('body').removeClass('search-mobile-is-active');
    (0, _jquery2.default)('.bc-sf-search-suggestion-mobile').css({
      display: 'none'
    });

    if (dataTop) {
      (0, _jquery2.default)('html, body').animate({
        scrollTop: Number((0, _jquery2.default)('body').attr('data-top'))
      }, 0);
    }
  }
});